export default "__VITE_ASSET__hciM8SLS__"